<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 pt-0>
        <v-data-table
          bordered
          :headers="headers"
          :items="orderData"
          hide-default-footer
          :items-per-page="itemsPerPage"
          class="row-pointer pb-12"
          @click:row="rowClicked"
          style=""
        >
          <!-- @click:row="rowClicked" -->
          <template v-slot:[`item.orderID`]="{ item }">
            <v-layout wrap justify-center pt-8>
              <v-flex xs12 align-self-center>
                <span>{{ item.orderID }}</span>
              </v-flex>
              <v-flex align-self-center xs12 text-left class="white--text" pt-1>
                <!-- <span style="width: 30% !important;background-color:red;padding-left:6px;padding-right:6px;padding-top:2px;padding-bottom:2px;border-radius:10px" v-if="item.isPreOrder == true">
              Pre Order
            </span> -->

                <v-btn
                  block
                  x-small
                  dark
                  color="error"
                  style="text-transform: none"
                  v-if="item.isPreOrder == true"
                >
                  Pre Order
                </v-btn>
              </v-flex>
            </v-layout>

            <br />
          </template>
          <template v-slot:[`item.totalAmount`]="{ item }">
            <v-layout wrap justify-center>
              <v-flex xs12 align-self-center pt-7>
                <span>{{ item.totalAmount }}</span> <br />
                <span v-if="item.isPromoCodeApplied"
                  ><v-btn
                    v-if="item.isPromoCodeApplied == true"
                    x-small
                    dark
                    color="green"
                    style="text-transform: none"
                  >
                    Coupon Applied</v-btn
                  ></span
                >
              </v-flex>
            </v-layout>
            <br />
          </template>

          <template v-slot:[`item.fullName`]="{ item }">
            <span style="width: 30% !important" v-if="item.uid">
              {{ item.uid.customerid.firstName }}
              {{ item.uid.customerid.lastName }}
            </span>
          </template>
          <template v-slot:[`item.subTotal`]="{ item }">
            <span style="width: 30% !important" v-if="item.subTotal">
              {{ parseInt(item.subTotal) }}
            </span>
          </template>
          <template v-slot:[`item.totalAnt`]="{ item }">
            <span style="width: 30% !important" v-if="item.totalAmount">
              {{ parseInt(item.totalAmount) }}
            </span>
          </template>
          <template v-slot:[`item.products`]="{ item }">
            <v-layout wrap justify-start>
              <v-flex
                lg12
                align-self-center
                text-left
                v-for="(items, i) in item.products"
                :key="i"
              >
                <span>
                  <span v-if="items.productName">{{ items.productName }} </span>
                  <span v-else>
                    {{ items.name }}
                  </span>

                  <span :key="i" style="color: red">X</span>
                  <span> {{ items.quantity }} </span>
                </span>
                <span class="text-uppercase">
                  <span>- </span>
                  <span class="text-bold">{{ items.sellerId.shopName }}</span>
                  <span v-if="i != item.products.length - 1">,</span>
                </span>
              </v-flex>
              <v-flex xs12> </v-flex>
            </v-layout>
          </template>
          <template v-slot:[`item.Orderdate`]="{ item }">
            <span v-if="item.create_date">
              <!-- {{ formatDate(item.create_date) }} -->
              {{ momentTime(item.create_date) }}
            </span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#FDAC53"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <!-- <v-dialog persistent v-model="editDialog" max-width="70%">
      <v-card>
        <v-card-title style="font-family:poppinssemibold;font-size:16px"
          >Request</v-card-title
        >
        <v-layout wrap>
          <v-flex xs12 align-self-center px-6>
            <v-layout wrap pt-2>
              <v-flex xs12 sm6 text-left>
                <span>Seller Code</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.usercode}}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap pt-2 v-if="editingItem.sellerProfileId">
              <v-flex xs12 sm6 text-left>
                <span>Seller Name</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.sellerProfileId.name}}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap pt-2 v-if="editingItem.email">
              <v-flex xs12 sm6 text-left>
                <span>Email</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.email}}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap pt-2 v-if="editingItem.phone">
              <v-flex xs12 sm6 text-left>
                <span>Phone</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.phone}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="getData(), (updateDialog = false)"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="updateStatus(dialogId, dialogStatus)"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
  props: ["orderData", "pages", "pageFilters", "orderStatus"],
  // props: ["fromDate","toDate","programme"],
  data() {
    return {
      currentPage: 1,
      // pages: 0,
      // sellerData: [],
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      itemsPerPage: 25,
      prevRoute: localStorage.getItem("LS_ROUTE_KEY"),

      headers: [
        // { text: "Sl No.", value: "slno", sortable: true },
        { text: "Order ID", value: "orderID", sortable: true },
        { text: "Customer Name", value: "fullName", width: "150" },
        {
          text: "Product(s) - Shop Name",
          value: "products",
          class: "text-center",
        },
        { text: "Product Total(INR)", value: "subTotal" },
        { text: "Delivery Charge", value: "deliveryCharge" },
        { text: "Total(INR)", value: "totalAnt" },
        { text: "Ordered Date", value: "Orderdate", width: "120" },
        // { text: "Payment Type", value: "paymentType", cellClass:"text-uppercase" },
        // { text: "Payment Status", value: "paymentStatus", cellClass:"text-uppercase" },
        // { text: "Action", value: "actions" },
      ],
    };
  },
  // watch: {
  //   currentPage() {
  //     this.winStepper();
  //   },
  // },

  computed: {
    pageFilters1() {
      if (this.$store.state.orderPageFilters) {
        return this.$store.state.orderPageFilters;
      } else {
        return {};
      }
    },
  },
  watch: {
    fromDate() {
      // this.getData()
    },
    toDate() {
      // this.getData()
    },
    programme() {
      // this.getData()
    },
    currentPage() {
      // this.getData();
      this.winStepper();
    },
    pageFilters: {
      handler(val) {
        console.log(val.uid, "pro");
        if (val) this.storeUpdation();
      },
      deep: true,
    },
  },
  beforeMount() {
    // this.getData()
    // this.winStepper();
    if (this.prevRoute == "/OrderInfo") {
      // this.uid=this.pageFilters1.uid
      // // this.fromDate=this.pageFilters1.fromDate
      // // this.toDate=this.pageFilters1.toDate
      // this.sellerId = this.pageFilters1.shop;
      this.currentPage = this.pageFilters1.currentPage;
      // console.log(this.pageFilters1.currentPage,"hygvc")
    }
  },
  methods: {
    storeUpdation() {
      // alert("hii")
      this.$store.commit("orderPageFilters", this.pageFilters);
    },
    momentTime(time) {
      var local = moment.utc(time).local().format("MMM-DD-YYYY h:mm A");
      return local;
    },
    winStepper() {
      // console.log("step", this.currentPage);
      this.$emit("stepper", {
        getData: true,
        currentPage: this.currentPage,
        pages: this.pages,
      });
    },
    rowClicked(item) {
      this.$router.push("/OrderInfo?order=" + item._id);
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/users/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          role: "Seller",
          status: this.orderStatus,
          count: 12,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.sellers = response.data.data;
            this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatTime(item) {
      if (!item) return;
      if (item) item = item.slice(11, 16);
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
  },
};
</script>
<style>
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
</style>